// The page's right-click menu: every item it can offer, by context, and which are on.

export const contextMenuItemCatalog: Record<string, { key: string; label: string; icon: string }[]> = {
  spellcheck: [
    { key: 'ignoreOnce', label: 'Ignore Once', icon: 'closeWindow' },
    { key: 'disableRule', label: 'Disable This Rule', icon: 'closeWindow' },
  ],
  link: [
    { key: 'openLink', label: 'Open Link', icon: 'link' },
    { key: 'editLink', label: 'Edit Link...', icon: 'link' },
    { key: 'copyLinkAddress', label: 'Copy Link Address', icon: 'copy' },
    { key: 'removeLink', label: 'Remove Link', icon: 'closeWindow' },
  ],
  image: [
    { key: 'editImageUrl', label: 'Edit Image URL...', icon: 'image' },
    { key: 'deleteImage', label: 'Delete Image', icon: 'closeWindow' },
  ],
  table: [
    { key: 'selectTable', label: 'Select Table', icon: 'table' },
    { key: 'insertRowAbove', label: 'Insert Row Above', icon: 'table' },
    { key: 'insertRowBelow', label: 'Insert Row Below', icon: 'table' },
    { key: 'deleteRow', label: 'Delete Row', icon: 'closeWindow' },
    { key: 'insertColumnLeft', label: 'Insert Column Left', icon: 'table' },
    { key: 'insertColumnRight', label: 'Insert Column Right', icon: 'table' },
    { key: 'deleteColumn', label: 'Delete Column', icon: 'closeWindow' },
    { key: 'mergeOrSplitCells', label: 'Merge or Split Cells', icon: 'table' },
    { key: 'headerRow', label: 'Header Row', icon: 'table' },
    { key: 'headerColumn', label: 'Header Column', icon: 'table' },
    { key: 'deleteTable', label: 'Delete Table', icon: 'closeWindow' },
  ],
  clipboard: [
    { key: 'cut', label: 'Cut', icon: 'cut' },
    { key: 'copy', label: 'Copy', icon: 'copy' },
    { key: 'paste', label: 'Paste', icon: 'paste' },
    { key: 'pastePlainText', label: 'Paste Plain Text', icon: 'exportTXT' },
  ],
  selection: [
    { key: 'bold', label: 'Bold', icon: 'bold' },
    { key: 'italic', label: 'Italic', icon: 'italic' },
    { key: 'underline', label: 'Underline', icon: 'underline' },
    { key: 'strikethrough', label: 'Strikethrough', icon: 'strikethrough' },
    { key: 'inlineCode', label: 'Inline Code', icon: 'inlineCode' },
    { key: 'clearFormatting', label: 'Clear Formatting', icon: 'fontSize' },
    { key: 'addLink', label: 'Add Link...', icon: 'link' },
    { key: 'flagLooseEnd', label: 'Flag as Loose End', icon: 'looseEnd' },
  ],
  caret: [
    { key: 'undo', label: 'Undo', icon: 'undo' },
    { key: 'redo', label: 'Redo', icon: 'redo' },
    { key: 'insertTable', label: 'Insert Table', icon: 'table' },
    { key: 'insertLink', label: 'Insert Link...', icon: 'link' },
    { key: 'insertHorizontalLine', label: 'Insert Horizontal Line', icon: 'horizontalRule' },
    { key: 'insertPageBreak', label: 'Insert Page Break', icon: 'pageBreak' },
    { key: 'insertDetails', label: 'Insert Collapsible Section', icon: 'details' },
    { key: 'flagLooseEnd', label: 'Add Loose End', icon: 'looseEnd' },
    { key: 'parkIdea', label: 'Park an Idea...', icon: 'parkIdea' },
  ],
  details: [
    { key: 'unsetDetails', label: 'Unwrap Collapsible Section', icon: 'closeWindow' },
  ],
  list: [
    { key: 'listStyle', label: 'List Style', icon: 'orderedList' },
    { key: 'listLevel', label: 'This Level', icon: 'bulletList' },
    { key: 'restartNumbering', label: 'Restart Numbering', icon: 'orderedList' },
    { key: 'continueNumbering', label: 'Continue Numbering', icon: 'orderedList' },
    { key: 'listOptions', label: 'List Options...', icon: 'orderedList' },
  ],
  looseEnd: [
    { key: 'editLooseEnd', label: 'Edit Loose End...', icon: 'looseEnd' },
    { key: 'resolveLooseEnd', label: 'Resolve Loose End', icon: 'looseEnd' },
    { key: 'removeLooseEnd', label: 'Remove Loose End', icon: 'closeWindow' },
  ],
  document: [
    { key: 'selectAll', label: 'Select All', icon: 'selectAll' },
    { key: 'jumpTop', label: 'Go to Top', icon: 'jumpTop' },
    { key: 'jumpBottom', label: 'Go to Bottom', icon: 'jumpBottom' },
  ],
}

export const contextMenuContexts: { id: string; label: string }[] = [
  { id: 'spellcheck', label: 'Spelling' },
  { id: 'link', label: 'Link' },
  { id: 'image', label: 'Image' },
  { id: 'table', label: 'Table' },
  { id: 'details', label: 'Collapsible' },
  { id: 'list', label: 'List' },
  { id: 'looseEnd', label: 'Loose End' },
  { id: 'clipboard', label: 'Clipboard' },
  { id: 'selection', label: 'Selection' },
  { id: 'caret', label: 'Caret' },
  { id: 'document', label: 'Document' },
]

export const defaultContextMenuItems: Record<string, string[]> = {
  spellcheck: ['ignoreOnce', 'disableRule'],
  link: ['openLink', 'editLink', 'copyLinkAddress', 'removeLink'],
  image: ['editImageUrl', 'deleteImage'],
  table: ['selectTable', 'insertRowAbove', 'insertRowBelow', 'deleteRow', 'insertColumnLeft', 'insertColumnRight', 'deleteColumn', 'mergeOrSplitCells', 'headerRow', 'headerColumn', 'deleteTable'],
  details: ['unsetDetails'],
  list: ['listStyle', 'listLevel', 'restartNumbering', 'continueNumbering', 'listOptions'],
  looseEnd: ['editLooseEnd', 'resolveLooseEnd', 'removeLooseEnd'],
  clipboard: ['cut', 'copy', 'paste', 'pastePlainText'],
  selection: ['bold', 'italic', 'underline', 'strikethrough', 'inlineCode', 'clearFormatting', 'addLink', 'flagLooseEnd'],
  caret: ['undo', 'redo', 'insertTable', 'insertDetails', 'insertLink', 'insertHorizontalLine', 'insertPageBreak', 'flagLooseEnd', 'parkIdea'],
  document: ['selectAll', 'jumpTop', 'jumpBottom'],
}

// Earlier default lists. A saved list that still matches one was never
// customized, so it picks up items added to the default since.
const legacyContextMenuDefaults: Record<string, string[][]> = {
  spellcheck: [['ignoreOnce']],
  document: [['selectAll']],
  table: [
    ['insertRowAbove', 'insertRowBelow', 'deleteRow', 'insertColumnLeft', 'insertColumnRight', 'deleteColumn', 'mergeOrSplitCells', 'deleteTable'],
    ['insertRowAbove', 'insertRowBelow', 'deleteRow', 'insertColumnLeft', 'insertColumnRight', 'deleteColumn', 'mergeOrSplitCells', 'headerRow', 'headerColumn', 'deleteTable'],
  ],
}

function isLegacyContextMenuDefault(ctxId: string, list: string[]): boolean {
  return (legacyContextMenuDefaults[ctxId] ?? []).some(
    (legacy) => legacy.length === list.length && legacy.every((key, i) => list[i] === key)
  )
}

export function deepMergeContextMenuItems(persisted?: Record<string, string[]>) {
  const merged: Record<string, string[]> = {}
  for (const ctxId of Object.keys(defaultContextMenuItems)) {
    const validKeys = new Set(contextMenuItemCatalog[ctxId].map((o) => o.key))
    const persistedArr = persisted && Array.isArray(persisted[ctxId]) ? persisted[ctxId] : null
    const upgraded = persistedArr && isLegacyContextMenuDefault(ctxId, persistedArr)
    merged[ctxId] = persistedArr && !upgraded
    ? persistedArr.filter((k) => validKeys.has(k))
    : [...defaultContextMenuItems[ctxId]]
  }
  return merged
}
